import React from "react";
import {
  createStyles,
  useMantineColorScheme,
  Box,
  Stack,
  Text,
  Center,
  Image,
  Space,
  Group,
  Anchor,
} from "@mantine/core";
import AppLogo from "./components/AppLogo";

import PlantoryCover1 from "./assets/plantory-cover-1.webp";
import PlantoryCover2 from "./assets/plantory-cover-2.webp";

import PlantoryScreen1 from "./assets/plantory-screen-1.webp";
import PlantoryScreen2 from "./assets/plantory-screen-2.webp";
import PlantoryScreen3 from "./assets/plantory-screen-3.webp";
import PlantoryScreen4 from "./assets/plantory-screen-4.webp";
import PlantoryScreen5 from "./assets/plantory-screen-5.webp";
import PlantoryScreen6 from "./assets/plantory-screen-6.webp";
import AppStoreButtonLight from "./assets/app_store_button-light.svg";
import AppStoreButtonDark from "./assets/app_store_button-dark.svg";

import { Link, useNavigate, useParams } from "react-router-dom";

function HomePage({ children, ...otherProps }) {
  const { classes } = useStyles();
  const navigation = useNavigate();
  const { colorScheme } = useMantineColorScheme();
  return (
    <Box className={classes.containerHero} {...otherProps}>
      <Box className={classes.root}>
        <Box className={classes.grid}>
          <Box className={classes.section}>
            <Center px={50} pt={30} pb={10}>
              <Stack spacing={0} justify="center">
                <Center>
                  <AppLogo
                    variant="white"
                    onClick={() => navigation("/")}
                    sx={{ cursor: "pointer" }}
                  />
                </Center>

                <Text
                  weight={900}
                  size={46}
                  className={classes.heroTitle}
                  align="center"
                >
                  Identify Plants & Disease
                </Text>
                <Text
                  weight={400}
                  size={24}
                  className={classes.heroText}
                  align="center"
                >
                  Transform every walk into a discovery journey. Identify
                  species, understand taxonomy, and build your botanical
                  knowledge
                </Text>
              </Stack>
            </Center>
          </Box>
          <Box className={classes.section}>
            <Image src={PlantoryCover1} />
            <Center mt={20}>
              <Anchor
                href="https://apps.apple.com/app/plantory-plant-identifier/id6755497280"
                target="_blank"
              >
                <Image
                  src={AppStoreButtonLight}
                  width={200}
                  alt="Download Plantory on the App Store"
                />
              </Anchor>
            </Center>
          </Box>
          <Space h={30} />
        </Box>
      </Box>
      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Image src={PlantoryScreen2} />
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  align="left"
                  sx={{
                    color: "black",
                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "1.7rem",
                    },
                  }}
                >
                  Expert Botanical Consultation
                </Text>
                <Text
                  weight={400}
                  size={24}
                  align="left"
                  sx={{
                    color: "black",
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  Access specialized knowledge on cultivation, propagation, and
                  plant physiology through AI-driven expertise
                </Text>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.container}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  className={classes.heroTitle}
                  align="left"
                  sx={{
                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "1.7rem",
                    },
                  }}
                >
                  Research Documentation
                </Text>
                <Text
                  weight={400}
                  size={24}
                  className={classes.heroText}
                  align="left"
                  sx={{
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  Generate comprehensive botanical reports and maintain detailed
                  cultivation records for serious plant enthusiasts
                </Text>
              </Stack>

              <Image src={PlantoryScreen3} />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Image src={PlantoryScreen5} w={"500px"} />
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  align="left"
                  sx={{
                    color: "black",
                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "1.7rem",
                    },
                  }}
                >
                  AI Botanist Assistant
                </Text>
                <Text
                  weight={400}
                  size={24}
                  align="left"
                  sx={{
                    color: "black",
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  Get expert botanical advice and cultivation tips powered by
                  advanced AI
                </Text>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className={classes.containerHero}>
        <Box className={classes.root}>
          <Box className={classes.grid}>
            <Box className={classes.section}>
              <Center p={50}>
                <Stack spacing={0} justify="center">
                  <Text
                    weight={900}
                    size={36}
                    className={classes.heroTitle}
                    align="center"
                    sx={{
                      "@media (max-width: 565px)": {
                        fontSize: "1.7rem",
                        lineHeight: "1.9rem",
                      },
                    }}
                  >
                    Identify Plants
                  </Text>
                  <Text
                    weight={400}
                    size={24}
                    className={classes.heroText}
                    align="center"
                    sx={{
                      "@media (max-width: 565px)": {
                        fontSize: "1.3rem",
                        lineHeight: "1.5rem",
                      },
                    }}
                  >
                    Identify plant species with advanced AI technology and
                    detailed botanical information
                  </Text>
                </Stack>
              </Center>
            </Box>
            <Box className={classes.section}>
              <Image src={PlantoryCover2} />
              <Center mt={20}>
                <Anchor
                  href="https://apps.apple.com/app/plantory-plant-identifier/id6755497280"
                  target="_blank"
                >
                  <Image
                    src={AppStoreButtonDark}
                    width={200}
                    alt="Download Plantory on the App Store"
                  />
                </Anchor>
              </Center>
            </Box>
            <Space h={30} />
          </Box>
        </Box>
      </Box>

      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  align="left"
                  sx={{
                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "2.1rem",
                    },
                  }}
                >
                  Precision Plant Diagnosis
                </Text>
                <Text
                  weight={400}
                  size={24}
                  align="left"
                  sx={{
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  Advanced pathogen detection and symptom analysis. Protect your
                  collection with early disease identification
                </Text>
              </Stack>

              <Image src={PlantoryScreen1} />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className={classes.container}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Image src={PlantoryScreen3} />
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  className={classes.heroTitle}
                  align="left"
                  sx={{
                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "1.7rem",
                    },
                  }}
                >
                  Disease Analysis
                </Text>
                <Text
                  weight={400}
                  size={24}
                  className={classes.heroText}
                  align="left"
                  sx={{
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  Identify plant diseases early and get treatment
                  recommendations from advanced AI analysis
                </Text>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  align="left"
                  sx={{
                    color: "black",
                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "1.7rem",
                    },
                  }}
                >
                  Export Plant & Disease Profiles
                </Text>
                <Text
                  weight={400}
                  size={24}
                  align="left"
                  sx={{
                    color: "black",
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  Save and share your botanical discoveries with detailed
                  reports and comprehensive plant profiles
                </Text>
              </Stack>
              <Image src={PlantoryScreen6} w={"500px"} />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Text weight={400} size={16} align="left" sx={{ color: "gray" }}>
                Made with ❤️ and ☕️ by Anatoli Niculeac<sup>©</sup> 2025
              </Text>
              <Group spacing={10} p={20} position="right">
                <Anchor
                  component={Link}
                  to={"/support"}
                  className={classes.link}
                >
                  <Text
                    weight={400}
                    size={16}
                    align="left"
                    sx={{ color: "gray" }}
                  >
                    Support
                  </Text>
                </Anchor>
                <Text
                  weight={400}
                  size={16}
                  align="left"
                  sx={{ color: "gray" }}
                >
                  |
                </Text>
                <Anchor component={Link} to={"/terms"} className={classes.link}>
                  <Text
                    weight={400}
                    size={16}
                    align="left"
                    sx={{ color: "gray" }}
                  >
                    Terms of use
                  </Text>
                </Anchor>
                <Text
                  weight={400}
                  size={16}
                  align="left"
                  sx={{ color: "gray" }}
                >
                  |
                </Text>
                <Anchor
                  component={Link}
                  to={"/privacy"}
                  className={classes.link}
                >
                  <Text
                    weight={400}
                    size={16}
                    align="left"
                    sx={{ color: "gray" }}
                  >
                    Privacy Policy
                  </Text>
                </Anchor>
                <Text
                  weight={400}
                  size={16}
                  align="left"
                  sx={{ color: "gray" }}
                >
                  |
                </Text>

                <Anchor
                  component={Link}
                  to={"/contact"}
                  className={classes.link}
                >
                  <Text
                    weight={400}
                    size={16}
                    align="left"
                    sx={{ color: "gray" }}
                  >
                    Contact
                  </Text>
                </Anchor>
              </Group>
              <Space h={10} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default HomePage;

const useStyles = createStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
    overflowX: "hidden",

    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },

  container: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",

    "@media (max-width: 768px)": {
      width: "100%",
    },
    width: "100%",
    height: "100%",

    backgroundColor: "#00C580",
  },
  containerHero: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",

    "@media (max-width: 768px)": {
      width: "100%",
    },
    width: "100%",
    height: "100%",

    backgroundColor: "#00C580",
  },
  containerTwo: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",

    "@media (max-width: 768px)": {
      width: "100%",
    },
    width: "100%",
    height: "100%",
    backgroundColor: "#FFFFFF",
  },

  section: {
    maxWidth: 980,
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: "1em",
    alignItems: "center",
    paddingLeft: 15,
    paddingRight: 15,
  },

  sectionTwo: {
    maxWidth: 980,
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: "1em",
    alignItems: "center",
    paddingLeft: 15,
    paddingRight: 15,
  },
  grid: {
    display: "grid",
    width: "100%",
    height: "100%",

    gridTemplateColumns: "auto",
    gridTemplateRows: "auto",

    "@media (max-width: 1023px)": {
      gridTemplateColumns: "auto",
      justifyContent: "stretch",
    },

    "@media (min-width: 1600px)": {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto",
      WebkitTransition: "300ms",
    },
  },
  flex: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",

    gap: 20,
  },
  //   grid: {
  //     display: 'grid',
  //     gridTemplateColumns: '1fr auto 1fr',
  //     gridTemplateRows: 'auto',
  //     justifyContent: 'space-between',

  //     '@media (max-width: 425px)': {
  //       gridTemplateColumns: '1fr',
  //       gridTemplateRows: 'auto',
  //       justifyContent: 'center',
  //       alignContent: 'center',
  //       justifyItems: 'center',
  //     },
  //   },

  link: {
    whiteSpace: "nowrap",
    textDecoration: "none",

    ":last-child": {
      borderRight: "none",
    },

    webkitTransition: "opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)",
    transition: "opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)",
    // WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    // outlineOffset: '-7px',

    ":hover": {
      transition: "0.5s color",
      textDecoration: "none",
      fontWeight: 600,
    },
    transition: "0.5s color",
  },
  heroTitle: {
    color: "white",
  },
  heroText: {
    color: "white",
  },
}));
